export const COMPLIANCE_APPLICATION_NUMBER_TYPE = 'local'
export const COMPLIANCE_APPLICATION_END_USER_TYPE = 'business'

export const TERMS_OF_SERVICE_CONTENT = `
By checking this box or using the Services, you confirm that you have read and agree to comply with:

• Plivo's Terms of Service
• Applicable telecom laws and regulations, including those set by the Telecom Regulatory Authority of India (TRAI) and the Department of Telecommunications (DoT)

You acknowledge that compliance is your sole responsibility. Any misuse or non-compliance may result in penalties, service suspension, or termination, and all liability rests with you.

You specifically agree that:
1. No unsolicited communication or telemarketing will be sent using this number.
2. All outbound calls or messages will be made only after receiving explicit consent from the recipient.
3. Recipients must be given a clear opt-out option, and all opt-out requests must be promptly and permanently honored.
4. Plivo reserves the right to take further action as necessary to enforce compliance.
`
